import { MapPinIcon, TagIcon } from "@heroicons/react/24/outline";
import LocationTypes from "./pages/LocationTypes";
import SiteManagement from "./pages/SiteManagement";

const routes = [
  {
    element: SiteManagement,
    href: "locations",
    icon: MapPinIcon,
    name: "Sites",
    permissions: ["MANAGE_WAREHOUSE_SITES"],
  },
  {
    element: LocationTypes,
    href: "location-types",
    icon: TagIcon,
    name: "Location types",
    permissions: ["MANAGE_WAREHOUSE_SITES"],
  },
];

export default routes;
